import * as methods from '../methods';
import { Resource } from '../Resource';
import * as transformers from '../transformers';
import crops from './crops';
const rootPath = 'cycles';
export const fromRaw = {
    get: (cycle) => {
        return {
            id: cycle.id,
            cropId: cycle.crop,
            startedAt: cycle.started_at,
            completedOn: cycle.completed_on
        };
    }
};
const toRaw = {
    create: ({ cropId, startedAt }) => ({
        crop: cropId,
        started_at: startedAt
    }),
    update: ({ startedAt, completedOn }) => ({
        started_at: startedAt,
        completed_on: completedOn
    }),
    close: ({ completedOn }) => ({
        completed_on: completedOn
    })
};
const cycles = Resource((requesterBuilder, config) => {
    const getMany = (query) => requesterBuilder({
        path: rootPath,
        requestCtx: {
            transform: transformers.paginatedResponse(fromRaw.get),
            params: {
                query: {
                    limit: query?.limit,
                    offset: query?.offset
                }
            }
        }
    });
    const get = methods.get({ requesterBuilder, rootPath, fromRaw: fromRaw.get });
    const buildKeysToInvalidate = (cropId) => (id) => [
        get(id).invalidationKey,
        getMany().invalidationKey,
        crops(requesterBuilder, config).getMany().invalidationKey,
        crops(requesterBuilder, config).get(cropId).invalidationKey
    ];
    return {
        getMany,
        get,
        getAll: methods.getAllPages({ getMany }),
        create: (cropId) => methods.create({
            rootPath,
            fromRaw: fromRaw.get,
            requesterBuilder,
            toRaw: toRaw.create,
            buildKeysToInvalidate: buildKeysToInvalidate(cropId)
        }),
        update: (cropId) => methods.update({
            rootPath,
            fromRaw: fromRaw.get,
            requesterBuilder,
            toRaw: toRaw.update,
            buildKeysToInvalidate: buildKeysToInvalidate(cropId)
        }),
        close: (cycleId, cropId) => requesterBuilder({
            path: `${rootPath}/${cycleId}/close`,
            requestCtx: {
                method: 'POST',
                transform: fromRaw.get,
                toRaw: toRaw.close
            },
            keysToInvalidate: [
                getMany().invalidationKey,
                crops(requesterBuilder, config).getMany().invalidationKey,
                crops(requesterBuilder, config).get(cropId).invalidationKey
            ]
        })
    };
});
export default cycles;
